import {templateModelReducer} from '../../helpers/template-model-reducer';

class duplicateTemplate {
    constructor($injector) {
        this.state = $injector.get('$state');
        this.translate = $injector.get('$translate');
        this.alert = $injector.get('Alert');
        this.api = $injector.get('$http');

        this.key = 'duplicate-template';
        this.title = this.translate.instant('templates.workflows.details.duplicate-template.title');
        this.level = 'highlight';
        this.icon = 'fal fa-copy';
        this.order = 30;
    }

    action(template, vm) {
        this.api
            .post('templates', {
                ...templateModelReducer(template),
                name: 'Copy: ' + template.name,
                global_template: true
            })
            .then(({data}) => {
                this.state.go('app.templates.details', {id: data.data.id});
            })
            .catch((e) => {
                this.alert.handle(e);
            })
    }

}

angular
    .module('festzelt-os.modules.templates')
    .factory('duplicateTemplate', [
        '$injector',
        ($injector) => new duplicateTemplate($injector)
    ]);




// WEBPACK FOOTER //
// ./src/app/modules/templates/workflows/details/duplicate-template.js